import { Card, Row } from 'react-bootstrap';
import { Bar, BarChart, CartesianGrid,  Cell,  Tooltip, XAxis, YAxis } from 'recharts';
import { CommentsByFeelings } from '../types';
import { COLOR, STYLE } from '../../../config/constraits';
import { useCurrentClient } from '../../auth/api/getCurrentClient';
import { useTranslation } from "react-i18next";
import { useRef } from 'react';
import { RootState } from '../../../redux/store';
import { useSelector } from 'react-redux';
import ChartShareActions from '../../../components/ChartShareActions';

interface CommentsByFeelingsProps {
  commentsByFeelings: CommentsByFeelings[]
}

export default function CommentsByFeelingsGrafic({ commentsByFeelings }: CommentsByFeelingsProps) {

  //const BAR_DATA = commentsByFeelings.sort((a,b)=> a.feelings - b.feelings);
    const { t } = useTranslation('dashboard');
  const BAR_DATA: CommentsByFeelings[] = Array.from({ length: 5 }, (_, i) => {
    const matchingData = commentsByFeelings.find((data) => data.feelings === i+1);

    return {
      feelings: i+1,
      comments: matchingData ? matchingData.comments : 0,
    };
  });

    const feelingchartRef = useRef<HTMLDivElement>(null);
    const selectedFilters = useSelector((state: RootState) => state.filters.dashboard.selectedFilters);


  const { data: currentClient } = useCurrentClient();

    return (
        <div ref={feelingchartRef}>
            <Card
                style={{
                    backgroundColor: "#F5F5F5",
                    border: "none",
                    borderRadius: STYLE.BORDER_RADIUS,
                    position: "relative"
                }}
                className="p-2 d-flex justify-content-center align-items-center text-center"
            >
                {/* Botones en la esquina superior derecha */}
                <div style={{ position: "absolute", top: "10px", right: "10px" }}>
                    <ChartShareActions
                        chartRef={feelingchartRef}
                        title={t("dashboard:feelingAnalysis.commentsByFeelingsGraficHeader")}
                        filters={selectedFilters}
                        t={t}
                    />
                </div>

                <Row className="w-70 d-flex justify-content-center align-items-center">
                    <h4 className="pt-2">{t("dashboard:feelingAnalysis.commentsByFeelingsGraficHeader")}</h4>

                    <BarChart width={730} height={250} data={BAR_DATA}>
                        <CartesianGrid vertical={false} />
                        <XAxis dataKey="feelings" tickLine={false} />
                        <YAxis dataKey="comments" tickLine={false} />
                        <Tooltip />
                        <Bar name="Comentaris" dataKey="comments" fill="#8884d8">
                            {BAR_DATA.map((item, index) => (
                                <Cell
                                    cursor="pointer"
                                    fill={item.feelings < (currentClient?.neutralReference || 4)
                                        ? COLOR.VERMELL
                                        : item.feelings > (currentClient?.positiveReference || 8)
                                            ? COLOR.VERD
                                            : COLOR.TARONJA
                                    }
                                    key={`cell-${index}`}
                                />
                            ))}
                        </Bar>
                    </BarChart>
                </Row>
            </Card>
        </div>
    );

}
